import React from 'react'
import { Logo } from '@/components/frontend/atoms/navigation/Logo'
import { FooterLink } from '@/components/frontend/atoms/navigation/FooterLink'
import { StatusPill } from '@/components/frontend/atoms/content/StatusPill'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import {
  FooterShell, FooterColumns, FooterColumn, FooterDescription, FooterBottom,
} from '@/components/frontend/atoms/layout/FooterShell'
import { CONTACT_EMAIL, GITHUB_URL, LINKEDIN_URL } from '@/lib/contact'
import { useTranslation } from '@/hooks/useTranslation'

const BRAND_NAME = 'CodeOfMario'

export const SiteFooter: React.FC = () => {
  const { t, lp } = useTranslation()
  const year = new Date().getFullYear()

  const exploreLinks = [
    { label: t('footer.services'), href: lp('/#servizi') },
    { label: t('footer.workflow'), href: lp('/#workflow') },
    { label: t('footer.about'), href: lp('/#about') },
    { label: t('footer.blog'), href: lp('/blog') },
    { label: t('footer.contact'), href: lp('/#contatti') },
  ]

  return (
    <FooterShell>
      <FooterColumns>
        <Stack gap="4" align="start">
          <Logo />
          <FooterDescription>{t('footer.description')}</FooterDescription>
          <StatusPill>{t('hero.status')}</StatusPill>
        </Stack>
        <FooterColumn title={t('footer.explore')}>
          {exploreLinks.map((link) => <FooterLink key={link.href} href={link.href}>{link.label}</FooterLink>)}
        </FooterColumn>
        <FooterColumn title={t('footer.connect')}>
          <FooterLink href={`mailto:${CONTACT_EMAIL}`} external>{CONTACT_EMAIL}</FooterLink>
          <FooterLink href={LINKEDIN_URL} external>LinkedIn</FooterLink>
          <FooterLink href={GITHUB_URL} external>GitHub</FooterLink>
        </FooterColumn>
      </FooterColumns>
      <FooterBottom>
        <span>&copy; {year} {BRAND_NAME}. {t('footer.rights')}</span>
        <span>{t('footer.made_in')}</span>
      </FooterBottom>
    </FooterShell>
  )
}
